import axios from 'axios';
import store from 'store';

const state = {
  claimTypes: {},
  paginatedClaimTypes: {},
};

const getters = {
  getClaimTypesSearched: st => (page, q, sortBy, order) => {
    axios.get(`claims/types?page=${page}&q=${q}&sort=${sortBy}&order=${order}`).then(res => {
      st.paginatedClaimTypes = res.data;
    });
  },
};

const mutations = {
  setClaimTypes: (st, payload) => {
    st.claimTypes = payload;
  },
  setPaginatedClaimTypes: (st, payload) => {
    st.paginatedClaimTypes = payload;
  },
};

const actions = {
  getClaimTypes: ({ commit }) => {
    if (store.get('permissions').indexOf('claims.types.index') >= 0) {
      axios.get(`claims/types?paginated=false`).then(res => commit('setClaimTypes', res.data));
    }
  },
  getPaginatedClaimTypes: ({ commit }) => {
    commit('setPaginatedClaimTypes', {});
    if (store.get('permissions').indexOf('claims.types.index') >= 0) {
      axios.get(`claims/types`).then(res => commit('setPaginatedClaimTypes', res.data));
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/claimTypes.js